import React, { useMemo, useState } from 'react';
import { Provider } from 'react-redux';
import { Container } from 'reactstrap';
import { StyleSheetManager } from 'styled-components';
import PropTypes from 'prop-types';

import rtlcss from 'stylis-rtlcss';
import SkeletonLayout from './shared/layouts/SkeletonLayout';
import store from './store';
import toggleStylesheet from './shared/helpers/toggleStylesheet';

const Main = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const language = localStorage.getItem('language') || 'en';

  const isRTL = useMemo(() => language === 'ar', [language]);

  if (!isLoaded) {
    toggleStylesheet({ isRTL: isRTL, isDark: false }, () => setIsLoaded(true));
    return (
      <Container fluid>
        <SkeletonLayout />
      </Container>
    );
  }

  return (
    <Provider store={store}>
      <StyleSheetManager stylisPlugins={isRTL ? [rtlcss] : []}>
        {children}
      </StyleSheetManager>
    </Provider>
  );
};

Main.propTypes = { children: PropTypes.node };

export default Main;
